<template>
  <div class="position">
    <div class="title">{{$t('meg.positioning')}}</div>
    <p style="font-size: .175rem;color: #818AA0;line-height: .1875rem;">Platform Positioning</p>
    <div class="posiMain">
        <div class="left_posi">
            <h1 style="font-size: .375rem;font-weight: 800;color: #FFFFFF;margin-top: .9625rem;margin-left: .3125rem;">{{$t('meg.resources')}}</h1>
            <p style="text-align: justify;font-size: .225rem;font-weight: 500;color: #FFFFFF;margin-top: .575rem;margin-left: .3125rem;margin-right: .25rem;line-height: .75rem;">{{$t('meg.urgent')}}</p>
            <div class="leftBottom">
                
            </div>
        </div>
        <div class="right_posi">
            <div class="rightMain"></div>
            <h1 style="font-size: .375rem;font-weight: 800;color: #002FA7;margin-left: .75rem;">{{$t('meg.driven')}}</h1>
            <p style="text-align: justify;font-size: .225rem;font-weight: 500;color: #000000;margin-top: .45rem;margin-left: .75rem;margin-right: .825rem;line-height: .5125rem;">{{$t('meg.manufacturing')}}</p>
        </div>
    </div>
  </div>
</template>

<script>
</script>

<style scoped>
.position {
    margin-top: 1.375rem;
    overflow: hidden;
}
.title {
    font-size: .3rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    color: #333333;
    /* margin-top: .8625rem; */
}
.posiMain {
    margin: .8125rem 1.7rem;
    display: flex;
}
.left_posi {
    /* height: 615px; */
    text-align: left;
    padding-bottom: .375rem;
    background: url("../../../assets/newImg/pobg.png") no-repeat;
}
.right_posi {
    /* height: 615px; */
    text-align: left;
    padding-bottom: .375rem;
    background: #F6F6F6;
    opacity: 1;
}
.leftBottom {
    margin-left: .5rem;
    margin-right: .5rem;
    height: 1.5rem;
    background: url("../../../assets/newImg/poshezhi.png") no-repeat;
    background-size: 100% 100%;
    margin-top: 1.875rem;
}
.rightMain {
    width: 7.8rem;
    height: 5.275rem;
    background: url("../../../assets/newImg/rightPosi.png") no-repeat;
    background-size: 100% 100%;
    margin-left: 1.0625rem;
    margin-top: .25rem;
}
</style>
